export default __webpack_public_path__ + "static/media/Background_00085.448caf3b.png";